/* eslint-disable @typescript-eslint/no-require-imports */
import { getScrambledArray } from '@Utils/miscUtils';
import { useClassStore } from '@Utils/useClassStore';
import { Asset } from 'expo-asset';
import { injectable } from 'inversify';
import { observable } from 'mobx';

import container from '~ioc/ioc';

const gridCardAssetsFiles = {
  mask1: require('@Assets/mask1.svg'),
  mask2: require('@Assets/mask2.svg'),
  mask3: require('@Assets/mask3.svg'),
  mask4: require('@Assets/mask4.svg'),
  mask5: require('@Assets/mask5.svg'),
  mask6: require('@Assets/mask6.svg'),
  mask7: require('@Assets/mask7.svg'),
  mask8: require('@Assets/mask8.svg'),
};

type GridCardAssetKey = keyof typeof gridCardAssetsFiles;

@injectable()
class CardGeometriesStore {
  private assets = observable.map<GridCardAssetKey, Asset>();
  private allocatedAssets = observable.map<string, Asset>();
  private scrambledAssetArray: Asset[] = [];

  constructor() {
    this.loadAllAssets().then();
    this.scrambleAssetArray();
  }

  getAsset = (key: string): Asset => {
    let asset = this.allocatedAssets.get(key);

    if (!asset) {
      asset = this.getRandomAsset(key);
    }

    return asset;
  };

  private getRandomAsset = (key: string): Asset => {
    if (!this.scrambledAssetArray.length) {
      this.scrambleAssetArray();
    }

    const randomIndex = Math.floor(
      Math.random() * this.scrambledAssetArray.length
    );
    const [asset] = this.scrambledAssetArray.splice(randomIndex, 1);

    this.allocatedAssets.set(key, asset);

    return asset;
  };

  private loadAllAssets = async () => {
    const entries = Object.entries(gridCardAssetsFiles);
    const keys = entries.map((entry) => entry[0]) as GridCardAssetKey[];
    const nodes = entries.map((entry) => entry[1]);

    const loaded = await Asset.loadAsync(nodes);
    loaded.forEach((asset, index) => this.assets.set(keys[index], asset)); // store assets fetched under respective map keys
  };

  private scrambleAssetArray = () => {
    this.scrambledAssetArray = getScrambledArray<Asset>(
      Array.from(this.assets.values())
    );
  };
}

export const useCardGeometriesStore = () =>
  useClassStore<CardGeometriesStore>(container.get(CardGeometriesStore));
